<style scoped>
    .outer {
        background: var(--color-progress);
        width: 100px;
        height: 10px;
        border-radius: 3px;
    }

    .inner {
        /*background: var(--color-success-light);*/
        /*background:var(--color-danger-light);*/
        /*background: lightgrey;*/
        /*width: 80px;*/
        height: 10px;
        border-radius: 3px;
    }

    .outerloss {
        background: var(--color-progress);
        width: 100px;
        height: 10px;
        border-radius: 3px;
    }

    .innerloss {
        /*background: var(--color-success-light);*/
        background:var(--color-danger-light);
        /*background: lightgrey;*/
        /*width: 30px;*/
        height: 10px;
        border-radius: 3px;
        float: right;
    }

    .gen {
        font-size: 13px;
    }

    .pause {
        opacity: 0.4;
    }

    div {
        /*border: 1px solid yellow;*/
    }
    td {
        /*border: 1px solid lightgreen;*/
    }

    .number {
        width: 82px;
    }
</style>

<template>
    <div class="gen progress-bar" :class="{pause: paused}">
        <table>
            <tr>
                <td class="gred number">
                    <Tooltip placement="top" :delay="500" content="Stop Loss">
                        <div v-if="sl !== '0'">{{ sl }}<br>{{ slPct }}%</div>
                    </Tooltip>
                </td>
                <td>
                    <Tooltip placement="top" :delay="500" :content="botStatus">
                        <div class="outerloss">
                            <div class="innerloss" :style="{ width: lossPct }"></div>
                        </div>
                    </Tooltip>
                </td>
                <td class="number">
                    <Tooltip placement="top" :delay="500">
                        {{ buy }}<br><span style="color: #737691"><span :class="{ggreen: lastPct >= 0 && !gray, gred: lastPct < 0 && !gray}">{{ lastPct }}%</span></span>
                        <div slot="content">
                            <p>{{ $text.tr('Цена покупки:') }} {{ buy }}</p>
                            <p>{{ $text.tr('Цена сейчас:') }} {{ last }}</p>
                        </div>
                    </Tooltip>
                </td>
                <td>
                    <Tooltip placement="top" :delay="500" :content="botStatus">
                        <div class="outer">
                            <div class="inner" :style="{ width: profitPct, background: gray ? 'var(--color-progress-gray)' : 'var(--color-success-light)' }"></div>
                        </div>
                    </Tooltip>
                </td>
                <td class="ggreen number">
                    <Tooltip placement="top" :delay="500" :content="$text.tr('Цена продажи')">
                        {{ sell }}<br>{{ sellPct }}%
                    </Tooltip>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import Decimal from 'decimal.js'
export default {
  name: 'BotProgress',
  props: ['buy', 'sl', 'sell', 'last', 'gray', 'paused'],
  data () {
    return {

    }
  },
  computed: {
    botStatus () {
      return this.gray ? this.$text.tr('Ожидает покупку') : this.$text.tr('Ожидает продажу')
    },
    lastPct () {
      const pct = new Decimal(this.last).sub(this.buy).div(this.buy).mul(100).toDecimalPlaces(2)
      return pct.toNumber()
    },
    profitPct () {
      const diff = new Decimal(this.sell).sub(this.buy)
      let pct = new Decimal(this.last).sub(this.buy).div(diff).mul(100).toDecimalPlaces(0)
      // console.log('pct', pct.toString())
      if (pct.lessThan(0)) {
        pct = new Decimal(0)
      }
      if (pct.greaterThan(100)) {
        pct = new Decimal(100)
      }
      return pct.toString() + 'px'
      // if (new Decimal(this.sell))
    },
    lossPct () {
      let diff = new Decimal(this.buy).mul(0.05)
      if (this.sl && this.sl !== '0') {
        diff = new Decimal(this.buy).sub(this.sl).abs()
      }
      let pct = new Decimal(this.last).sub(this.buy).div(diff).mul(100).toDecimalPlaces(0)
      // console.log('pct', pct.toString())
      if (pct.greaterThan(0)) {
        pct = new Decimal(0)
      }
      if (pct.lessThan(-100)) {
        pct = new Decimal(-100)
      }
      return pct.abs().toString() + 'px'
      // if (new Decimal(this.sell))
    },
    slPct () {
      return new Decimal(this.sl).sub(this.buy).mul(100).div(this.buy).toDecimalPlaces(2).toString()
    },
    sellPct () {
      return new Decimal(this.sell).sub(this.buy).mul(100).div(this.buy).toDecimalPlaces(2).toString()
    }
  }
}
</script>
